export default __webpack_public_path__ + "static/media/ab.291cfab7.jpg";